import isFunction from "lodash/isFunction";

import {Button} from "@/components/button/Button.tsx";

interface FormOverlayButtonsProps {
  disabled?: boolean;
  form?: string;
  submitText?: string;
  onClick?: () => void;
  cancelText?: string;
  hasCancelButton?: boolean;
  hasSubmitButton?: boolean;
  onSubmit?: () => void;
  isSecondaryLevel?: boolean;
}

export function FormOverlayButtons({
  cancelText,
  disabled,
  form,
  onClick,
  submitText,
  hasSubmitButton,
  hasCancelButton,
  onSubmit,
  isSecondaryLevel,
}: FormOverlayButtonsProps) {
  return (
    <>
      {hasCancelButton && (
        <Button
          onClick={onClick}
          type="button"
          variant={hasSubmitButton ? "secondary" : "primary"}
          data-bs-dismiss={isSecondaryLevel || isFunction(onClick) ? undefined : "modal"}
        >
          {cancelText || "Cancel"}
        </Button>
      )}
      {hasSubmitButton && (
        <Button type="submit" onClick={onSubmit} disabled={disabled} form={form}>
          {submitText || "Save"}
        </Button>
      )}
    </>
  );
}
